import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { login, user, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      const from = location.state?.from?.pathname || '/';
      navigate(from);
    }
  }, [user, navigate, location]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!email.trim() || !password) {
      setError('Por favor completa todos los campos');
      return;
    }

    try {
      setIsSubmitting(true);
      await login(email, password);
    } catch (err) {
      setError(err.message || 'Error al iniciar sesion');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="loading loading-spinner loading-lg" />
      </div>
    );
  }

  return (
    <div className="login-shell">
      <div className="login-layout">
        <section className="login-story">
          <p className="page-eyebrow">Centro de control</p>
          <div className="page-header">
            <h1 className="page-title">AfiliadosCEM</h1>
            <p className="page-subtitle">
              Gestiona ventas, plataformas, productos y conversiones desde un panel
              operativo pensado para lectura rapida y decisiones diarias.
            </p>
          </div>

          <div className="context-chip-row">
            <span className="context-chip">
              <strong>Reporting</strong>
              <span>ventas y comisiones</span>
            </span>
            <span className="context-chip">
              <strong>Seguimiento</strong>
              <span>plataformas y articulos</span>
            </span>
            <span className="context-chip">
              <strong>Control</strong>
              <span>estado y conversion</span>
            </span>
          </div>

          <div className="login-story-grid">
            <div className="story-card">
              <span className="story-card-title">Vision unificada</span>
              <p className="story-card-copy">
                Una sola vista para revisar rendimiento por periodo, plataforma y estado.
              </p>
            </div>
            <div className="story-card">
              <span className="story-card-title">Operacion diaria</span>
              <p className="story-card-copy">
                Entradas claras, tablas limpias y acceso rapido a tareas de mantenimiento.
              </p>
            </div>
            <div className="story-card">
              <span className="story-card-title">Acceso seguro</span>
              <p className="story-card-copy">
                Solo usuarios autorizados pueden entrar al panel y gestionar los datos.
              </p>
            </div>
          </div>
        </section>

        <div className="premium-panel login-form-card">
          <form onSubmit={handleSubmit} className="card-body">
            <div className="login-form-head">
              <p className="panel-kicker">Acceso privado</p>
              <h2 className="login-form-title">Iniciar sesion</h2>
              <p className="login-form-copy">
                Introduce tus credenciales para acceder al panel operativo premium.
              </p>
            </div>

            {error && (
              <div className="alert alert-error mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 shrink-0 stroke-current" fill="none" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>{error}</span>
              </div>
            )}

            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold">Email</span>
              </label>
              <input
                type="email"
                placeholder="tu@email.com"
                className="input input-bordered w-full"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                disabled={isSubmitting}
                required
              />
            </div>

            <div className="form-control mt-4">
              <label className="label">
                <span className="label-text font-semibold">Contrasena</span>
              </label>
              <input
                type="password"
                placeholder="........"
                className="input input-bordered w-full"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                disabled={isSubmitting}
                required
              />
            </div>

            <div className="form-control mt-6">
              <button
                type="submit"
                className={`btn btn-primary w-full ${isSubmitting ? 'loading' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Validando acceso...' : 'Entrar al panel'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
